import { motion } from 'framer-motion';
import { cn } from '../ui/utils';

/**
 * Tooltip customizado pra Recharts (substitui o default cinza).
 * Estilo card moderno com sombra suave, animado.
 */
export function ChartTooltip({ active, payload, label, formatter, className }) {
  if (!active || !payload || !payload.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 4, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
      className={cn(
        'rounded-xl border border-slate-200 bg-white px-3 py-2 shadow-lg shadow-slate-900/10',
        className
      )}
    >
      {label && <p className="mb-1.5 text-xs font-semibold text-slate-700">{label}</p>}
      <div className="space-y-1">
        {payload.map((entry, idx) => (
          <div key={idx} className="flex items-center gap-2 text-xs">
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ backgroundColor: entry.color || entry.payload?.fill || entry.fill }}
            />
            <span className="text-slate-500">{entry.name}:</span>
            <span className="font-semibold text-slate-900">
              {formatter ? formatter(entry.value, entry.name, entry) : entry.value}
            </span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}

export default ChartTooltip;
